import React from 'react';

import { useRouteMatch } from 'react-router';

import IconFemtasy from 'components/IconFemtasy';

import history, { goBack } from 'config/history';

import { localizeUrl } from 'helpers/locales';

import { useTracking } from 'hooks/useTracking';

import './style.scss';

export interface TopNavigationProps {
  actions?: ReadonlyArray<React.ReactNode>;
  backLink?: string;
  onBackClick?: () => void;
  showBackButton?: boolean;
  showNavigation?: boolean;
  shouldRunTracking?: () => boolean;
}

const TopNavigation = ({
  actions = [],
  backLink = '',
  onBackClick,
  showBackButton = true,
  showNavigation = true,
  shouldRunTracking,
}: TopNavigationProps) => {
  const match = useRouteMatch();

  const { trackContentInteraction } = useTracking();

  const onGoBack = () => {
    if (shouldRunTracking && shouldRunTracking() === false) {
      return;
    }

    onBackClick && onBackClick();

    trackContentInteraction(
      'click',
      'top-navigation-back',
      backLink === '' ? 'history-back' : backLink,
    );

    if (backLink === '') {
      history.goBack();
      return;
    }

    goBack({ fallback: localizeUrl(match.url, backLink) });
  };

  if (!showNavigation) {
    return null;
  }

  return (
    <div className="TopNavigation">
      <div className="TopNavigation__bar">
        <div>
          {showBackButton && (
            <IconFemtasy
              className="back-arrow"
              icon="Arrowleft"
              onClick={onGoBack}
              testId="top-navigation-back-arrow"
            />
          )}
        </div>

        <div className="TopNavigation__bar__actions">
          {actions?.map((action, index) => (
            <div data-testid="top-bar-action" key={index}>
              {action}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TopNavigation;
